const toNumber = (value) => Number(value)

const toBoolean = (value) => Boolean(value)

export const toCreatePayload = (formData) => ({
  device_code: toNumber(formData.device_code),
  max_camera: toNumber(formData.max_camera),
  index_start: toNumber(formData.index_start),
  is_support_adas: toBoolean(formData.is_support_adas),
  is_support_dms: toBoolean(formData.is_support_dms),
})

export const toUpdatePayload = (formData) => {
  const payload = toCreatePayload(formData)
  delete payload.device_code
  return payload
}
